import { DatePipe } from '@angular/common';
import { event_status } from '../../../../../assets/constData/event_status';
import { EventMapCard } from './event-map.model';
import { extractEventVenueLocation, GeoPoint } from './event-map-geo';

export interface MappedEventPin {
  readonly card: EventMapCard;
  readonly address: string;
  readonly point: GeoPoint | null;
  readonly distanceKm: number | null;
  readonly source: unknown;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object') {
    return null;
  }
  return value as Record<string, unknown>;
}

function readId(event: Record<string, unknown>): string {
  return String(event['id'] ?? '');
}

function statusLabel(statusId: unknown): string {
  const match = event_status.find((item) => Number(item.value) === Number(statusId));
  return match?.class_name ?? '';
}

export function mapEventToPin(
  event: unknown,
  datePipe: DatePipe,
): MappedEventPin | null {
  const record = asRecord(event);
  if (!record) {
    return null;
  }
  const id = readId(record);
  if (!id) {
    return null;
  }
  const venue = extractEventVenueLocation(event);
  const start = record['event_start_date'];
  const end = record['event_end_date'];
  const startText = start ? datePipe.transform(String(start), 'MMM d, y') : '';
  const endText = end ? datePipe.transform(String(end), 'MMM d, y') : '';
  const dates = startText && endText ? `${startText} - ${endText}` : startText ?? '';
  const statusId = record['event_status'];
  const registered = Number(record['registered_participants'] ?? 0);

  return {
    address: venue.address,
    point: venue.point,
    distanceKm: null,
    source: event,
    card: {
      id,
      name: String(record['name'] ?? ''),
      city: venue.address,
      statusId,
      statusLabel: statusLabel(statusId),
      dates,
      thumb: String(record['thumbnail'] || record['banner'] || ''),
      cta: Number(statusId) === 1 ? 'Register now' : 'View details',
      registeredCount: Number.isFinite(registered) ? registered : 0,
    },
  };
}
